import { useEffect, useState } from "react";
import { X, Download } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onBip = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (localStorage.getItem("tp_install_dismissed") !== "1") setShow(true);
    };
    const onInstalled = () => {
      setShow(false);
      setDeferred(null);
      localStorage.setItem("tp_install_dismissed", "1");
    };
    window.addEventListener("beforeinstallprompt", onBip);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBip);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* ignore */ }
    setShow(false);
    setDeferred(null);
  };

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("tp_install_dismissed", "1");
  };

  if (!show) return null;
  return (
    <div data-testid="pwa-install-banner" className="fixed bottom-4 inset-x-4 z-[60] max-w-md mx-auto animate-fade-in-up">
      <div className="flex items-center gap-3 p-3 bg-white shadow-xl border border-[#E5E0D8] rounded-2xl">
        <img src="/talenta-logo.png" alt="TalentaPath" className="h-11 w-11 rounded-xl object-contain shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-[#1A1C1A]">Tambahkan ke Layar Utama</p>
          <p className="text-xs text-[#5C5F5C]">Pasang TalentaPath untuk akses cepat seperti aplikasi.</p>
        </div>
        <button onClick={install} data-testid="pwa-install-btn"
          className="px-3.5 py-2 rounded-full bg-[#E25E3E] text-white text-sm font-medium inline-flex items-center gap-1.5 hover:bg-[#C94F31] transition-colors shrink-0">
          <Download className="h-4 w-4" /> Pasang
        </button>
        <button onClick={dismiss} data-testid="pwa-install-dismiss" className="p-1.5 text-[#9C9A94] hover:text-[#1A1C1A] shrink-0" aria-label="Tutup">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
